/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  CreateReminderRequest,
  DeleteReminderRequest,
  EditReminderRequest,
  GetFilteredRemindersPagedParams,
  GetOpenRemindersForUsersParams,
  GetReminderByIdParams,
  GetReminderPermissionParams,
  PermissionType,
  ReminderDto,
  ReminderDtoPagination
} from '../../model';

import { customInstance } from '../../../mutator';
import type { ErrorType , BodyType } from '../../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getHasOwnOpenRemindersUrl = () => {


  

  return `/api/Reminder/HasOwnOpenReminders`
}

export const hasOwnOpenReminders = async ( options?: RequestInit): Promise<boolean> => {
  
  return customInstance<boolean>(getHasOwnOpenRemindersUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getHasOwnOpenRemindersQueryKey = () => {
    return [
    `/api/Reminder/HasOwnOpenReminders`
    ] as const;
    }

    
export const getHasOwnOpenRemindersQueryOptions = <TData = Awaited<ReturnType<typeof hasOwnOpenReminders>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hasOwnOpenReminders>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHasOwnOpenRemindersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof hasOwnOpenReminders>>> = ({ signal }) => hasOwnOpenReminders({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hasOwnOpenReminders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type HasOwnOpenRemindersQueryResult = NonNullable<Awaited<ReturnType<typeof hasOwnOpenReminders>>>
export type HasOwnOpenRemindersQueryError = ErrorType<unknown>


export function useHasOwnOpenReminders<TData = Awaited<ReturnType<typeof hasOwnOpenReminders>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hasOwnOpenReminders>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hasOwnOpenReminders>>,
          TError,
          Awaited<ReturnType<typeof hasOwnOpenReminders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useHasOwnOpenReminders<TData = Awaited<ReturnType<typeof hasOwnOpenReminders>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hasOwnOpenReminders>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hasOwnOpenReminders>>,
          TError,
          Awaited<ReturnType<typeof hasOwnOpenReminders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useHasOwnOpenReminders<TData = Awaited<ReturnType<typeof hasOwnOpenReminders>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hasOwnOpenReminders>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useHasOwnOpenReminders<TData = Awaited<ReturnType<typeof hasOwnOpenReminders>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hasOwnOpenReminders>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getHasOwnOpenRemindersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getHasOwnOpenRemindersSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof hasOwnOpenReminders>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof hasOwnOpenReminders>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHasOwnOpenRemindersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof hasOwnOpenReminders>>> = ({ signal }) => hasOwnOpenReminders({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof hasOwnOpenReminders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type HasOwnOpenRemindersSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof hasOwnOpenReminders>>>
export type HasOwnOpenRemindersSuspenseQueryError = ErrorType<unknown>


export function useHasOwnOpenRemindersSuspense<TData = Awaited<ReturnType<typeof hasOwnOpenReminders>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof hasOwnOpenReminders>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useHasOwnOpenRemindersSuspense<TData = Awaited<ReturnType<typeof hasOwnOpenReminders>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof hasOwnOpenReminders>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useHasOwnOpenRemindersSuspense<TData = Awaited<ReturnType<typeof hasOwnOpenReminders>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof hasOwnOpenReminders>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useHasOwnOpenRemindersSuspense<TData = Awaited<ReturnType<typeof hasOwnOpenReminders>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof hasOwnOpenReminders>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getHasOwnOpenRemindersSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetReminderByIdUrl = (params?: GetReminderByIdParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Reminder/GetReminderById?${stringifiedParams}` : `/api/Reminder/GetReminderById`
}

export const getReminderById = async (params?: GetReminderByIdParams, options?: RequestInit): Promise<ReminderDto> => {
  
  return customInstance<ReminderDto>(getGetReminderByIdUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetReminderByIdQueryKey = (params?: GetReminderByIdParams,) => {
    return [
    `/api/Reminder/GetReminderById`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetReminderByIdQueryOptions = <TData = Awaited<ReturnType<typeof getReminderById>>, TError = ErrorType<unknown>>(params?: GetReminderByIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReminderById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReminderByIdQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReminderById>>> = ({ signal }) => getReminderById(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReminderById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetReminderByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getReminderById>>>
export type GetReminderByIdQueryError = ErrorType<unknown>


export function useGetReminderById<TData = Awaited<ReturnType<typeof getReminderById>>, TError = ErrorType<unknown>>(
 params: undefined |  GetReminderByIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReminderById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReminderById>>,
          TError,
          Awaited<ReturnType<typeof getReminderById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetReminderById<TData = Awaited<ReturnType<typeof getReminderById>>, TError = ErrorType<unknown>>(
 params?: GetReminderByIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReminderById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReminderById>>,
          TError,
          Awaited<ReturnType<typeof getReminderById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetReminderById<TData = Awaited<ReturnType<typeof getReminderById>>, TError = ErrorType<unknown>>(
 params?: GetReminderByIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReminderById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetReminderById<TData = Awaited<ReturnType<typeof getReminderById>>, TError = ErrorType<unknown>>(
 params?: GetReminderByIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReminderById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetReminderByIdQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetReminderByIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getReminderById>>, TError = ErrorType<unknown>>(params?: GetReminderByIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReminderById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReminderByIdQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReminderById>>> = ({ signal }) => getReminderById(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReminderById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetReminderByIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getReminderById>>>
export type GetReminderByIdSuspenseQueryError = ErrorType<unknown>


export function useGetReminderByIdSuspense<TData = Awaited<ReturnType<typeof getReminderById>>, TError = ErrorType<unknown>>(
 params: undefined |  GetReminderByIdParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReminderById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetReminderByIdSuspense<TData = Awaited<ReturnType<typeof getReminderById>>, TError = ErrorType<unknown>>(
 params?: GetReminderByIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReminderById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetReminderByIdSuspense<TData = Awaited<ReturnType<typeof getReminderById>>, TError = ErrorType<unknown>>(
 params?: GetReminderByIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReminderById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetReminderByIdSuspense<TData = Awaited<ReturnType<typeof getReminderById>>, TError = ErrorType<unknown>>(
 params?: GetReminderByIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReminderById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetReminderByIdSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetFilteredRemindersPagedUrl = (params?: GetFilteredRemindersPagedParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Reminder/GetFilteredRemindersPaged?${stringifiedParams}` : `/api/Reminder/GetFilteredRemindersPaged`
}

export const getFilteredRemindersPaged = async (params?: GetFilteredRemindersPagedParams, options?: RequestInit): Promise<ReminderDtoPagination> => {
  
  return customInstance<ReminderDtoPagination>(getGetFilteredRemindersPagedUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetFilteredRemindersPagedQueryKey = (params?: GetFilteredRemindersPagedParams,) => {
    return [
    `/api/Reminder/GetFilteredRemindersPaged`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetFilteredRemindersPagedQueryOptions = <TData = Awaited<ReturnType<typeof getFilteredRemindersPaged>>, TError = ErrorType<unknown>>(params?: GetFilteredRemindersPagedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFilteredRemindersPaged>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFilteredRemindersPagedQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFilteredRemindersPaged>>> = ({ signal }) => getFilteredRemindersPaged(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFilteredRemindersPaged>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetFilteredRemindersPagedQueryResult = NonNullable<Awaited<ReturnType<typeof getFilteredRemindersPaged>>>
export type GetFilteredRemindersPagedQueryError = ErrorType<unknown>


export function useGetFilteredRemindersPaged<TData = Awaited<ReturnType<typeof getFilteredRemindersPaged>>, TError = ErrorType<unknown>>(
 params: undefined |  GetFilteredRemindersPagedParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFilteredRemindersPaged>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFilteredRemindersPaged>>,
          TError,
          Awaited<ReturnType<typeof getFilteredRemindersPaged>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFilteredRemindersPaged<TData = Awaited<ReturnType<typeof getFilteredRemindersPaged>>, TError = ErrorType<unknown>>(
 params?: GetFilteredRemindersPagedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFilteredRemindersPaged>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFilteredRemindersPaged>>,
          TError,
          Awaited<ReturnType<typeof getFilteredRemindersPaged>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFilteredRemindersPaged<TData = Awaited<ReturnType<typeof getFilteredRemindersPaged>>, TError = ErrorType<unknown>>(
 params?: GetFilteredRemindersPagedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFilteredRemindersPaged>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetFilteredRemindersPaged<TData = Awaited<ReturnType<typeof getFilteredRemindersPaged>>, TError = ErrorType<unknown>>(
 params?: GetFilteredRemindersPagedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFilteredRemindersPaged>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetFilteredRemindersPagedQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetFilteredRemindersPagedSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getFilteredRemindersPaged>>, TError = ErrorType<unknown>>(params?: GetFilteredRemindersPagedParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFilteredRemindersPaged>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFilteredRemindersPagedQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFilteredRemindersPaged>>> = ({ signal }) => getFilteredRemindersPaged(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFilteredRemindersPaged>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetFilteredRemindersPagedSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getFilteredRemindersPaged>>>
export type GetFilteredRemindersPagedSuspenseQueryError = ErrorType<unknown>


export function useGetFilteredRemindersPagedSuspense<TData = Awaited<ReturnType<typeof getFilteredRemindersPaged>>, TError = ErrorType<unknown>>(
 params: undefined |  GetFilteredRemindersPagedParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFilteredRemindersPaged>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFilteredRemindersPagedSuspense<TData = Awaited<ReturnType<typeof getFilteredRemindersPaged>>, TError = ErrorType<unknown>>(
 params?: GetFilteredRemindersPagedParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFilteredRemindersPaged>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFilteredRemindersPagedSuspense<TData = Awaited<ReturnType<typeof getFilteredRemindersPaged>>, TError = ErrorType<unknown>>(
 params?: GetFilteredRemindersPagedParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFilteredRemindersPaged>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetFilteredRemindersPagedSuspense<TData = Awaited<ReturnType<typeof getFilteredRemindersPaged>>, TError = ErrorType<unknown>>(
 params?: GetFilteredRemindersPagedParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFilteredRemindersPaged>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetFilteredRemindersPagedSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetOpenRemindersForUsersUrl = (params?: GetOpenRemindersForUsersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["userIds"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Reminder/GetOpenRemindersForUsers?${stringifiedParams}` : `/api/Reminder/GetOpenRemindersForUsers`
}

export const getOpenRemindersForUsers = async (params?: GetOpenRemindersForUsersParams, options?: RequestInit): Promise<ReminderDto[]> => {
  
  return customInstance<ReminderDto[]>(getGetOpenRemindersForUsersUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetOpenRemindersForUsersQueryKey = (params?: GetOpenRemindersForUsersParams,) => {
    return [
    `/api/Reminder/GetOpenRemindersForUsers`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetOpenRemindersForUsersQueryOptions = <TData = Awaited<ReturnType<typeof getOpenRemindersForUsers>>, TError = ErrorType<unknown>>(params?: GetOpenRemindersForUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOpenRemindersForUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOpenRemindersForUsersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOpenRemindersForUsers>>> = ({ signal }) => getOpenRemindersForUsers(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOpenRemindersForUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetOpenRemindersForUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getOpenRemindersForUsers>>>
export type GetOpenRemindersForUsersQueryError = ErrorType<unknown>


export function useGetOpenRemindersForUsers<TData = Awaited<ReturnType<typeof getOpenRemindersForUsers>>, TError = ErrorType<unknown>>(
 params: undefined |  GetOpenRemindersForUsersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOpenRemindersForUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOpenRemindersForUsers>>,
          TError,
          Awaited<ReturnType<typeof getOpenRemindersForUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetOpenRemindersForUsers<TData = Awaited<ReturnType<typeof getOpenRemindersForUsers>>, TError = ErrorType<unknown>>(
 params?: GetOpenRemindersForUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOpenRemindersForUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOpenRemindersForUsers>>,
          TError,
          Awaited<ReturnType<typeof getOpenRemindersForUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetOpenRemindersForUsers<TData = Awaited<ReturnType<typeof getOpenRemindersForUsers>>, TError = ErrorType<unknown>>(
 params?: GetOpenRemindersForUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOpenRemindersForUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetOpenRemindersForUsers<TData = Awaited<ReturnType<typeof getOpenRemindersForUsers>>, TError = ErrorType<unknown>>(
 params?: GetOpenRemindersForUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOpenRemindersForUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetOpenRemindersForUsersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetOpenRemindersForUsersSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getOpenRemindersForUsers>>, TError = ErrorType<unknown>>(params?: GetOpenRemindersForUsersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOpenRemindersForUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOpenRemindersForUsersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOpenRemindersForUsers>>> = ({ signal }) => getOpenRemindersForUsers(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOpenRemindersForUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetOpenRemindersForUsersSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getOpenRemindersForUsers>>>
export type GetOpenRemindersForUsersSuspenseQueryError = ErrorType<unknown>


export function useGetOpenRemindersForUsersSuspense<TData = Awaited<ReturnType<typeof getOpenRemindersForUsers>>, TError = ErrorType<unknown>>(
 params: undefined |  GetOpenRemindersForUsersParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOpenRemindersForUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetOpenRemindersForUsersSuspense<TData = Awaited<ReturnType<typeof getOpenRemindersForUsers>>, TError = ErrorType<unknown>>(
 params?: GetOpenRemindersForUsersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOpenRemindersForUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetOpenRemindersForUsersSuspense<TData = Awaited<ReturnType<typeof getOpenRemindersForUsers>>, TError = ErrorType<unknown>>(
 params?: GetOpenRemindersForUsersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOpenRemindersForUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetOpenRemindersForUsersSuspense<TData = Awaited<ReturnType<typeof getOpenRemindersForUsers>>, TError = ErrorType<unknown>>(
 params?: GetOpenRemindersForUsersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOpenRemindersForUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetOpenRemindersForUsersSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getCreateReminderUrl = () => {


  

  return `/api/Reminder/CreateReminder`
}

export const createReminder = async (createReminderRequest: CreateReminderRequest, options?: RequestInit): Promise<ReminderDto> => {
  
  return customInstance<ReminderDto>(getCreateReminderUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createReminderRequest,)
  }
);}




export const getCreateReminderMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createReminder>>, TError,{data: BodyType<CreateReminderRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createReminder>>, TError,{data: BodyType<CreateReminderRequest>}, TContext> => {

const mutationKey = ['createReminder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createReminder>>, {data: BodyType<CreateReminderRequest>}> = (props) => {
          const {data} = props ?? {};

          return  createReminder(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateReminderMutationResult = NonNullable<Awaited<ReturnType<typeof createReminder>>>
    export type CreateReminderMutationBody = BodyType<CreateReminderRequest>
    export type CreateReminderMutationError = ErrorType<unknown>

    export const useCreateReminder = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createReminder>>, TError,{data: BodyType<CreateReminderRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createReminder>>,
        TError,
        {data: BodyType<CreateReminderRequest>},
        TContext
      > => {

      const mutationOptions = getCreateReminderMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getEditReminderUrl = () => {


  

  return `/api/Reminder/EditReminder`
}

export const editReminder = async (editReminderRequest: EditReminderRequest, options?: RequestInit): Promise<ReminderDto> => {
  
  return customInstance<ReminderDto>(getEditReminderUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      editReminderRequest,)
  }
);}




export const getEditReminderMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editReminder>>, TError,{data: BodyType<EditReminderRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof editReminder>>, TError,{data: BodyType<EditReminderRequest>}, TContext> => {

const mutationKey = ['editReminder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof editReminder>>, {data: BodyType<EditReminderRequest>}> = (props) => {
          const {data} = props ?? {};

          return  editReminder(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type EditReminderMutationResult = NonNullable<Awaited<ReturnType<typeof editReminder>>>
    export type EditReminderMutationBody = BodyType<EditReminderRequest>
    export type EditReminderMutationError = ErrorType<unknown>

    export const useEditReminder = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editReminder>>, TError,{data: BodyType<EditReminderRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof editReminder>>,
        TError,
        {data: BodyType<EditReminderRequest>},
        TContext
      > => {

      const mutationOptions = getEditReminderMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getDeleteReminderUrl = () => {


  

  return `/api/Reminder/DeleteReminder`
}

export const deleteReminder = async (deleteReminderRequest: DeleteReminderRequest, options?: RequestInit): Promise<boolean> => {
  
  return customInstance<boolean>(getDeleteReminderUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      deleteReminderRequest,)
  }
);}




export const getDeleteReminderMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteReminder>>, TError,{data: BodyType<DeleteReminderRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteReminder>>, TError,{data: BodyType<DeleteReminderRequest>}, TContext> => {

const mutationKey = ['deleteReminder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteReminder>>, {data: BodyType<DeleteReminderRequest>}> = (props) => {
          const {data} = props ?? {};

          return  deleteReminder(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteReminderMutationResult = NonNullable<Awaited<ReturnType<typeof deleteReminder>>>
    export type DeleteReminderMutationBody = BodyType<DeleteReminderRequest>
    export type DeleteReminderMutationError = ErrorType<unknown>

    export const useDeleteReminder = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteReminder>>, TError,{data: BodyType<DeleteReminderRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteReminder>>,
        TError,
        {data: BodyType<DeleteReminderRequest>},
        TContext
      > => {

      const mutationOptions = getDeleteReminderMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getGetReminderPermissionUrl = (params?: GetReminderPermissionParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Reminder/GetReminderPermission?${stringifiedParams}` : `/api/Reminder/GetReminderPermission`
}

export const getReminderPermission = async (params?: GetReminderPermissionParams, options?: RequestInit): Promise<PermissionType> => {
  
  return customInstance<PermissionType>(getGetReminderPermissionUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetReminderPermissionQueryKey = (params?: GetReminderPermissionParams,) => {
    return [
    `/api/Reminder/GetReminderPermission`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetReminderPermissionQueryOptions = <TData = Awaited<ReturnType<typeof getReminderPermission>>, TError = ErrorType<unknown>>(params?: GetReminderPermissionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReminderPermission>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReminderPermissionQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReminderPermission>>> = ({ signal }) => getReminderPermission(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReminderPermission>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetReminderPermissionQueryResult = NonNullable<Awaited<ReturnType<typeof getReminderPermission>>>
export type GetReminderPermissionQueryError = ErrorType<unknown>


export function useGetReminderPermission<TData = Awaited<ReturnType<typeof getReminderPermission>>, TError = ErrorType<unknown>>(
 params: undefined |  GetReminderPermissionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReminderPermission>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReminderPermission>>,
          TError,
          Awaited<ReturnType<typeof getReminderPermission>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetReminderPermission<TData = Awaited<ReturnType<typeof getReminderPermission>>, TError = ErrorType<unknown>>(
 params?: GetReminderPermissionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReminderPermission>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReminderPermission>>,
          TError,
          Awaited<ReturnType<typeof getReminderPermission>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetReminderPermission<TData = Awaited<ReturnType<typeof getReminderPermission>>, TError = ErrorType<unknown>>(
 params?: GetReminderPermissionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReminderPermission>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetReminderPermission<TData = Awaited<ReturnType<typeof getReminderPermission>>, TError = ErrorType<unknown>>(
 params?: GetReminderPermissionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReminderPermission>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetReminderPermissionQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetReminderPermissionSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getReminderPermission>>, TError = ErrorType<unknown>>(params?: GetReminderPermissionParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReminderPermission>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReminderPermissionQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReminderPermission>>> = ({ signal }) => getReminderPermission(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReminderPermission>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetReminderPermissionSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getReminderPermission>>>
export type GetReminderPermissionSuspenseQueryError = ErrorType<unknown>


export function useGetReminderPermissionSuspense<TData = Awaited<ReturnType<typeof getReminderPermission>>, TError = ErrorType<unknown>>(
 params: undefined |  GetReminderPermissionParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReminderPermission>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetReminderPermissionSuspense<TData = Awaited<ReturnType<typeof getReminderPermission>>, TError = ErrorType<unknown>>(
 params?: GetReminderPermissionParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReminderPermission>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetReminderPermissionSuspense<TData = Awaited<ReturnType<typeof getReminderPermission>>, TError = ErrorType<unknown>>(
 params?: GetReminderPermissionParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReminderPermission>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetReminderPermissionSuspense<TData = Awaited<ReturnType<typeof getReminderPermission>>, TError = ErrorType<unknown>>(
 params?: GetReminderPermissionParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReminderPermission>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetReminderPermissionSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getHasOverdueReminderForCurrentUserUrl = () => {


  

  return `/api/Reminder/HasOverdueReminderForCurrentUser`
}

export const hasOverdueReminderForCurrentUser = async ( options?: RequestInit): Promise<boolean> => {
  
  return customInstance<boolean>(getHasOverdueReminderForCurrentUserUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getHasOverdueReminderForCurrentUserQueryKey = () => {
    return [
    `/api/Reminder/HasOverdueReminderForCurrentUser`
    ] as const;
    }

    
export const getHasOverdueReminderForCurrentUserQueryOptions = <TData = Awaited<ReturnType<typeof hasOverdueReminderForCurrentUser>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hasOverdueReminderForCurrentUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHasOverdueReminderForCurrentUserQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof hasOverdueReminderForCurrentUser>>> = ({ signal }) => hasOverdueReminderForCurrentUser({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hasOverdueReminderForCurrentUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type HasOverdueReminderForCurrentUserQueryResult = NonNullable<Awaited<ReturnType<typeof hasOverdueReminderForCurrentUser>>>
export type HasOverdueReminderForCurrentUserQueryError = ErrorType<unknown>


export function useHasOverdueReminderForCurrentUser<TData = Awaited<ReturnType<typeof hasOverdueReminderForCurrentUser>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof hasOverdueReminderForCurrentUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hasOverdueReminderForCurrentUser>>,
          TError,
          Awaited<ReturnType<typeof hasOverdueReminderForCurrentUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useHasOverdueReminderForCurrentUser<TData = Awaited<ReturnType<typeof hasOverdueReminderForCurrentUser>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hasOverdueReminderForCurrentUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hasOverdueReminderForCurrentUser>>,
          TError,
          Awaited<ReturnType<typeof hasOverdueReminderForCurrentUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useHasOverdueReminderForCurrentUser<TData = Awaited<ReturnType<typeof hasOverdueReminderForCurrentUser>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hasOverdueReminderForCurrentUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useHasOverdueReminderForCurrentUser<TData = Awaited<ReturnType<typeof hasOverdueReminderForCurrentUser>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hasOverdueReminderForCurrentUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getHasOverdueReminderForCurrentUserQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getHasOverdueReminderForCurrentUserSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof hasOverdueReminderForCurrentUser>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof hasOverdueReminderForCurrentUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHasOverdueReminderForCurrentUserQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof hasOverdueReminderForCurrentUser>>> = ({ signal }) => hasOverdueReminderForCurrentUser({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof hasOverdueReminderForCurrentUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type HasOverdueReminderForCurrentUserSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof hasOverdueReminderForCurrentUser>>>
export type HasOverdueReminderForCurrentUserSuspenseQueryError = ErrorType<unknown>


export function useHasOverdueReminderForCurrentUserSuspense<TData = Awaited<ReturnType<typeof hasOverdueReminderForCurrentUser>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof hasOverdueReminderForCurrentUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useHasOverdueReminderForCurrentUserSuspense<TData = Awaited<ReturnType<typeof hasOverdueReminderForCurrentUser>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof hasOverdueReminderForCurrentUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useHasOverdueReminderForCurrentUserSuspense<TData = Awaited<ReturnType<typeof hasOverdueReminderForCurrentUser>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof hasOverdueReminderForCurrentUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useHasOverdueReminderForCurrentUserSuspense<TData = Awaited<ReturnType<typeof hasOverdueReminderForCurrentUser>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof hasOverdueReminderForCurrentUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getHasOverdueReminderForCurrentUserSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getCountOverdueRemindersForCurrentUserUrl = () => {


  

  return `/api/Reminder/CountOverdueRemindersForCurrentUser`
}

export const countOverdueRemindersForCurrentUser = async ( options?: RequestInit): Promise<number> => {
  
  return customInstance<number>(getCountOverdueRemindersForCurrentUserUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getCountOverdueRemindersForCurrentUserQueryKey = () => {
    return [
    `/api/Reminder/CountOverdueRemindersForCurrentUser`
    ] as const;
    }

    
export const getCountOverdueRemindersForCurrentUserQueryOptions = <TData = Awaited<ReturnType<typeof countOverdueRemindersForCurrentUser>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countOverdueRemindersForCurrentUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCountOverdueRemindersForCurrentUserQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof countOverdueRemindersForCurrentUser>>> = ({ signal }) => countOverdueRemindersForCurrentUser({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof countOverdueRemindersForCurrentUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type CountOverdueRemindersForCurrentUserQueryResult = NonNullable<Awaited<ReturnType<typeof countOverdueRemindersForCurrentUser>>>
export type CountOverdueRemindersForCurrentUserQueryError = ErrorType<unknown>


export function useCountOverdueRemindersForCurrentUser<TData = Awaited<ReturnType<typeof countOverdueRemindersForCurrentUser>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof countOverdueRemindersForCurrentUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof countOverdueRemindersForCurrentUser>>,
          TError,
          Awaited<ReturnType<typeof countOverdueRemindersForCurrentUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useCountOverdueRemindersForCurrentUser<TData = Awaited<ReturnType<typeof countOverdueRemindersForCurrentUser>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countOverdueRemindersForCurrentUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof countOverdueRemindersForCurrentUser>>,
          TError,
          Awaited<ReturnType<typeof countOverdueRemindersForCurrentUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useCountOverdueRemindersForCurrentUser<TData = Awaited<ReturnType<typeof countOverdueRemindersForCurrentUser>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countOverdueRemindersForCurrentUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useCountOverdueRemindersForCurrentUser<TData = Awaited<ReturnType<typeof countOverdueRemindersForCurrentUser>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countOverdueRemindersForCurrentUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getCountOverdueRemindersForCurrentUserQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getCountOverdueRemindersForCurrentUserSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof countOverdueRemindersForCurrentUser>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof countOverdueRemindersForCurrentUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCountOverdueRemindersForCurrentUserQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof countOverdueRemindersForCurrentUser>>> = ({ signal }) => countOverdueRemindersForCurrentUser({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof countOverdueRemindersForCurrentUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type CountOverdueRemindersForCurrentUserSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof countOverdueRemindersForCurrentUser>>>
export type CountOverdueRemindersForCurrentUserSuspenseQueryError = ErrorType<unknown>


export function useCountOverdueRemindersForCurrentUserSuspense<TData = Awaited<ReturnType<typeof countOverdueRemindersForCurrentUser>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof countOverdueRemindersForCurrentUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useCountOverdueRemindersForCurrentUserSuspense<TData = Awaited<ReturnType<typeof countOverdueRemindersForCurrentUser>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof countOverdueRemindersForCurrentUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useCountOverdueRemindersForCurrentUserSuspense<TData = Awaited<ReturnType<typeof countOverdueRemindersForCurrentUser>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof countOverdueRemindersForCurrentUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useCountOverdueRemindersForCurrentUserSuspense<TData = Awaited<ReturnType<typeof countOverdueRemindersForCurrentUser>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof countOverdueRemindersForCurrentUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getCountOverdueRemindersForCurrentUserSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




